import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchLicenseProductNameByName, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class LicenseProductNameTypeahead extends Component {
    static propTypes = {
        fetchLicenseProductNameByName: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
        suggestions: PropTypes.array
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchLicenseProductNameByName(LicenseProductNameTypeahead.name, { term });
    };

    render() {
        const options = this.props.suggestions.map(productName => ({
            label: productName.licenseProductName,
            value: productName.id
        }));

        return (
            <MultiTypeahead
                options={options}
                isMulti={false}
                isClearable={this.props.isClearable}
                value={this.props.value}
                titleId="licenseProductName"
                isRequired
                animatedPlaceholder
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={this.props.onChangeSuggestion}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === LicenseProductNameTypeahead.name
            ? typeahead.list
            : LicenseProductNameTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchLicenseProductNameByName,
    clearTypeahed
})(LicenseProductNameTypeahead);
